import { useContext } from 'react'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { useQueryClient } from '@tanstack/react-query'
import { AuthContext } from '@/features/Auth/application/AuthContext'

import { routeTree } from './routeTree.gen'
import { RouterContext } from './routes/__root'

import 'react-datepicker/dist/react-datepicker.css'
import 'modern-normalize/modern-normalize.css'
import './App.css'

export const router = createRouter({
  routeTree,
  context: {
    queryClient: undefined!,
    authContext: undefined!,
  } as RouterContext,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export default function App() {
  const queryClient = useQueryClient()
  const authContext = useContext(AuthContext)

  return (
    <RouterProvider
      router={router}
      context={{
        queryClient,
        authContext,
      }}
    />
  )
}
